import React, { ReactElement } from "react";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import WorkPage from "../pages/WorkPage";
import FileSystemPage from "../pages/FileSystemPage";
import ErrorPage from "../pages/ErrorPage";
import DemoPage from "../pages/DemoPage";
import DevPage from "../pages/DevPage";
import CompareVersionsViewerPage from "../pages/CompareVersions";

export type Router = {
    path: string;
    element: ReactElement;
};
export const publicRoutes: Router[] = [
    { path: "/login", element: <LoginPage /> },
    { path: "/demo", element: <DemoPage /> },
    { path: "/dev", element: <DevPage /> },
    { path: "/files", element: <FileSystemPage /> },
    { path: "/viewer", element: <WorkPage /> },
    { path: "/compareViewer", element: <CompareVersionsViewerPage /> },
];
export const adminRoutes: Router[] = [
    { path: "/register", element: <RegisterPage /> },
];

export const errorRout: Router = { path: "/error", element: <ErrorPage /> };
